<template>
  <div class="system">
    <div class="system-title">敬在智慧管理产品体系</div>
    <div class="system-content">
      <div v-for="(system, systemIndex) in systemList" :key="systemIndex" class="system-item">
        <div class="system-item-title" @click="toPage(system.url)">
          <img class="system-item-title-icon" :src="system.titleIcon"></img>
          <span style="margin-left: 7.5px;" class="item-title">
            {{ system.title }}
          </span>
        </div>
        <div class="system-item-info">{{ system.info }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { config } from "../../../constant/config.js";
import { toPage } from '@/utils/index.js'
export default {
  data() {
    return {
      systemList: config.system,
    };
  },
  mounted() { },
  methods: {
    toPage

  },
};
</script>

<style lang="less" scoped>
.system {
  padding: @commonPadding;
  background-color: @mainTextColor;
  color: @black;

  .system-title {
    font-size: 40px;
    line-height: 40px;
    margin-bottom: 50px;
  }

  .system-content {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 52px;
    border-top: 1px solid @mainGrayColor3;
    border-bottom: 1px solid @mainGrayColor3;

    .system-item {
      padding: 50px 0px;

      /*   &:nth-last-child(2),
      &:last-child {
      } */

      .system-item-title {
        font-size: 20px;
        /* font-weight: 400; */
        margin-bottom: 20px;
        position: relative;
        width: fit-content;
        padding-right: 80px;
        cursor: pointer;
        display: flex;
        align-items: center;

        .system-item-title-icon {
          width: 30px;
        }

        &::before {
          content: "";
          display: none;
          width: 20px;
          height: 14px;
          position: absolute;
          background: url(../../../assets/images/home/arrow.svg);
          background-size: 20px 14px;
          top: 10px;
          transform: rotate(180deg);
          right: 100px;
        }

        &:hover {
          &::before {
            display: block;
            animation-name: showArrow;
            animation-duration: 0.3s;
            animation-fill-mode: forwards;
          }
        }
      }

      .system-item-info {
        font-size: 14px;
        height: 48px;
        color: @mainGrayColor2;
        line-height: 24px;
        /* 新增：两行溢出省略 */
        display: -webkit-box;
        -webkit-line-clamp: 2;
        /* 显示行数 */
        -webkit-box-orient: vertical;
        overflow: hidden;
        /* 隐藏溢出内容 */
        text-overflow: ellipsis;
        /* 末尾显示省略号 */
      }
    }
  }
}

@media @mobile {
  .system {
    padding: 60px @commonPadding_h5 0 @commonPadding_h5;

    .system-title {
      font-size: @fontSize24;
    }

    .system-content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 20px;
      border: none;
      text-align: center;

      .system-item {
        padding:0 0 20px 0;

        .system-item-title {
          font-size: @fontSize14;
          width: 100%;
          padding: 0;
          display: flex;
          align-items: center;
          flex-direction: column;

          .item-title {
            width: 100%;
            display: block;
          }

          .system-item-title-icon {
            width: 30px;
          }

          &::before {
            display: none;
          }

          &:hover {
            &::before {
              display: none;
            }
          }
        }

        .system-item-info {
          display: none;
        }
      }
    }
  }
}

@keyframes showArrow {
  0% {
    right: 10px;
  }

  100% {
    right: 0px;
  }
}
</style>
